import script from "./DocumentViewerPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentViewerPanel.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentViewerPanel.vue?vue&type=style&index=0&id=772baf48&lang=css"

const __exports__ = script;

export default __exports__